import { render, staticRenderFns } from "./QuickLinkButton.vue?vue&type=template&id=3cd10c8f&scoped=true&lang=pug"
import script from "./QuickLinkButton.vue?vue&type=script&lang=js"
export * from "./QuickLinkButton.vue?vue&type=script&lang=js"
import style0 from "./QuickLinkButton.vue?vue&type=style&index=0&id=3cd10c8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd10c8f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VIcon})
